<template>
  <div class="min-h-screen bg-gray-50 px-4 pt-6 pb-28" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      

      <div class="bg-white rounded-xl border border-gray-200 p-6 text-center">
        <p class="text-sm text-gray-500 mb-2">موجودی فعلی</p>
        <p v-if="loading" class="text-lg font-bold text-orange-600">در حال دریافت...</p>
        <p v-else class="text-3xl font-bold text-gray-900 flex items-baseline justify-center gap-2">
          <span>{{ balanceAmount }} </span>
          <span class="text-base font-bold text-gray-900">تومان</span>
        </p>
       
      </div>

      <div class="bg-blue-50 border border-blue-100 rounded-xl p-4 text-sm text-blue-800 leading-relaxed">
        در این بخش فقط وضعیت کیف پول شما نمایش داده می‌شود. برای افزایش موجودی از دکمه شارژ کیف پول استفاده کنید.
      </div>

      <button
        type="button"
        class="hidden w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-4 rounded-xl transition-colors flex items-center justify-center gap-2"
        @click="openChargeModal()"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        شارژ کیف پول
      </button>
    </div>

    <!-- Charge Modal -->
    <div
      v-if="showChargeModal"
      class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-start justify-center p-4 pt-20"
      @click.self="closeChargeModal()"
    >
      <div class="bg-white rounded-2xl shadow-xl w-full max-w-lg overflow-hidden">
        <div class="bg-gradient-to-r from-orange-500 to-amber-600 px-6 py-4 text-white">
          <div class="flex items-center justify-between">
            <h2 class="text-lg font-bold w-full text-center">شارژ کیف پول</h2>
            <button
              type="button"
              class="w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center flex-shrink-0"
              @click="closeChargeModal()"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>

        <div class="px-6 py-5 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">مبلغ شارژ (تومان)</label>
            <input
              v-model="chargeAmount"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              placeholder="مثلاً 1,000,000"
              class="wallet-charge-input w-full rounded-xl px-4 py-3 text-lg font-bold text-gray-900 bg-white focus:outline-none focus:ring-2 focus:ring-orange-500"
              style="border: 1px solid #d1d5db !important;"
            />
          </div>
          <p class="text-xs text-gray-500">
            پس از تایید، به درگاه پرداخت هدایت می‌شوید و پس از پرداخت موفق، موجودی کیف پول افزایش می یابد.
          </p>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 flex gap-3">
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-xl transition-colors"
            :disabled="charging"
            @click="closeChargeModal()"
          >
            انصراف
          </button>
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-700 hover:to-amber-700 text-white font-bold rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="charging || !isValidChargeAmount"
            @click="submitCharge()"
          >
            {{ charging ? 'در حال پردازش...' : 'ادامه و پرداخت' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '../../main'

export default {
  data() {
    return {
      balance: '',
      loading: false,
      showChargeModal: false,
      chargeAmount: '',
      charging: false,
    }
  },
  computed: {
    isValidChargeAmount() {
      return this.chargeAmountValue >= 1000
    },
    chargeAmountValue() {
      return parseInt(this.parseAmountInput(this.chargeAmount), 10) || 0
    },
    balanceAmount() {
      return String(this.balance).trim()  | "0"
    },
  },
  watch: {
    chargeAmount() {
      const formatted = this.formatAmountInput(this.chargeAmount)
      if (this.chargeAmount !== formatted) {
        this.chargeAmount = formatted
      }
    },
  },
  mounted() {
    this.fetchBalance()
  },
  methods: {
    parseWalletBalance(data) {
      if (!data) return ''
      if (Array.isArray(data)) {
        const item = data.find(x => x.AccValue != null) || data[0]
        return item ? this.parseWalletBalance(item) : ''
      }
      if (data.items && Array.isArray(data.items)) {
        return this.parseWalletBalance(data.items)
      }
      const raw = data.AccValue ?? data.accValue
      return raw != null ? String(raw) : ''
    },
    getProfile() {
      return JSON.parse(localStorage.getItem('profile') || '{}')
    },
    normalizeMobile(phone) {
      if (!phone) return ''
      phone = phone.toString().trim().replace(/[\s\-]/g, '')
      if (phone.startsWith('+98')) return '0' + phone.substring(3)
      if (phone.startsWith('98') && phone.length > 10) return '0' + phone.substring(2)
      if (phone.startsWith('9') && phone.length === 10) return '0' + phone
      return phone
    },
    fetchBalance() {
      const profile = this.getProfile()
      if (!profile.UserId) return
      this.loading = true
      this.axios.post('/GetDashAccBalanceDetailsForApp', { UserId: profile.UserId }, { show_pros: false })
        .then(response => {
          this.balance = this.parseWalletBalance(response.data)
        })
        .catch(() => {
          this.balance = ''
        })
        .finally(() => {
          this.loading = false
        })
    },
    openChargeModal() {
      this.chargeAmount = ''
      this.showChargeModal = true
    },
    closeChargeModal() {
      if (this.charging) return
      this.showChargeModal = false
      this.chargeAmount = ''
    },
    submitCharge() {
      if (!this.isValidChargeAmount) {
        bus.$emit('show_toast', [2000, 'مبلغ شارژ را وارد کنید (حداقل ۱,۰۰۰ تومان)'])
        return
      }
      const profile = this.getProfile()
      const amount = this.chargeAmountValue
      const formData = new FormData()
      formData.append('UserId', String(profile.UserId))
      formData.append('Amount', String(amount))
      formData.append('customer_mobile', this.normalizeMobile(localStorage.getItem('phone')))
      formData.append('customer_name', profile.UserName || '')
      formData.append('summary', 'شارژ کیف پول تکنسین')
      formData.append('document_code', 'WALLET_CHARGE_' + profile.UserId)

      this.charging = true
      this.axios.post('/AddPersonWalletCharge', formData, {})
        .then(response => {
          if (response.data.error === 0) {
            this.handleChargeSuccess(response.data)
            return
          }
          return this.chargeViaPayGateway(amount, profile)
        })
        .catch(() => this.chargeViaPayGateway(amount, profile))
        .finally(() => {
          this.charging = false
        })
    },
    handleChargeSuccess(data) {
      if (data.unique_code) {
        window.open('https://pay.zoodkomak.com/i/' + data.unique_code, '_self')
        return
      }
      bus.$emit('show_toast', [2000, data.msg || 'درخواست شارژ با موفقیت ثبت شد'])
      this.closeChargeModal()
      this.fetchBalance()
    },
    chargeViaPayGateway(amount, profile) {
      const products = [{
        name: 'شارژ کیف پول',
        price: amount,
        summary: 'شارژ کیف پول تکنسین',
      }]
      const formData = new FormData()
      formData.append('products', JSON.stringify(products))
      formData.append('customer_mobile', this.normalizeMobile(localStorage.getItem('phone')))
      formData.append('customer_name', profile.UserName || '')
      formData.append('economic_code', '')
      formData.append('document_code', 'WALLET_CHARGE_' + profile.UserId)
      formData.append('summary', 'شارژ کیف پول تکنسین')
      formData.append('use_wallet', '0')
      formData.append('wallet_amount', '0')
      formData.append('payable_amount', String(amount))
      formData.append('total_amount', String(amount))
      formData.append('user_id', String(profile.UserId))
      formData.append('charge_wallet', '1')

      return this.axios.post('https://pay.zoodkomak.com/api/add_factor_from_zoodkomak', formData, {})
        .then(response => {
          if (response.data.error === 0) {
            this.handleChargeSuccess(response.data)
          } else {
            bus.$emit('show_toast', [2000, response.data.msg || 'خطا در ایجاد فاکتور شارژ'])
          }
        })
        .catch(() => {
          bus.$emit('show_toast', [2000, 'خطا در اتصال به درگاه پرداخت'])
        })
    },
  },
}
</script>

<style scoped>
.wallet-charge-input:focus {
  border-color: #f97316 !important;
}
</style>
